export default __webpack_public_path__ + "static/media/dart.4e34b583.png";